module.exports = __webpack_public_path__ + "img/36.97a63072.jpg";